<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.9982 2.05389C6.5066 2.05389 2.04785 6.51261 2.04785 12.0045C2.04785 17.4965 6.5066 21.9552 11.9982 21.9552C17.4897 21.9552 21.9484 17.4965 21.9484 12.0045C21.9484 6.51261 17.4897 2.05389 11.9982 2.05389ZM11.9982 3.63851C16.615 3.63851 20.3641 7.38724 20.3641 12.0045C20.3641 16.6218 16.615 20.3706 11.9982 20.3706C7.38133 20.3706 3.63214 16.6218 3.63214 12.0045C3.63214 7.38724 7.38133 3.63851 11.9982 3.63851ZM11.2055 6.15601V11.2263L8.85853 8.69122C8.56128 8.37025 8.05989 8.35094 7.73962 8.64808C7.41836 8.94513 7.39928 9.44685 7.69553 9.76772L11.4167 13.7868C11.6379 14.0261 11.9841 14.1052 12.2874 13.9862C12.5907 13.8673 12.7908 13.5746 12.7908 13.2485V6.15601C12.7908 5.71874 12.4355 5.36375 11.9982 5.36375C11.5608 5.36375 11.2055 5.71874 11.2055 6.15601Z"
      fill="#141414"
    />
  </svg>
</template>

<script>
export default {
  name: 'StateWaitingAlt'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
